/**
 * Live /apply-now — same flow as /apply-loan
 *   Mobile OTP → PAN + DigiLocker Aadhaar → Loan form → Thank You
 *
 * Mobile OTP APIs: TaskApi/sendOtp1 and TaskApi/verifyOtp1
 *
 * Differences from /apply-loan:
 *   - DigiLocker opens in the same tab (no popup)
 *   - State / city / pincode are not prefilled from Aadhaar
 */
import React from "react";
import ApplyLoan from "./apply-loan";

const ApplyNow = () => <ApplyLoan sameTabDigilocker prefillLocation={false} />;

export default ApplyNow;
